function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "5E179E6A-7DCA-4783-BDA6-F8619398457F");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Styleguide-+-UI-Components",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Styleguide",
  transform: "translate(-944.000000, -5131.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Notifications/Error",
  transform: "translate(927.000000, 5119.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon_Error",
  transform: "translate(17.000000, 12.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "alert-triangle",
  transform: "translate(3.000000, 4.000000)",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.63636364
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.60090909,1.52181818 L0.670909091,13.0909091 C0.380161332,13.5944179 0.3784254,14.2143929 0.666348971,14.719522 C0.954272542,15.2246511 1.48860983,15.5390644 2.07,15.5454545 L15.93,15.5454545 C16.5113902,15.5390644 17.0457275,15.2246511 17.333651,14.719522 C17.6215746,14.2143929 17.6198387,13.5944179 17.3290909,13.0909091 L10.3990909,1.52181818 C10.1024463,1.03277563 9.5719796,0.734118542 9,0.734118542 C8.4280204,0.734118542 7.89755372,1.03277563 7.60090909,1.52181818 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 9,
  y1: 5.72727273,
  x2: 9,
  y2: 9,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 9,
  y1: 12.2727273,
  x2: 9.00818182,
  y2: 12.2727273,
  id: "Path"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  opacity: 0,
  x: 0,
  y: 0,
  width: 24,
  height: 24
})))));

var SvgIconError = function SvgIconError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon_Error.547b137b.svg";
export { ForwardRef as ReactComponent };